import React from "react";
import Header from "../Header/Header";
import "./Hero.css";
import hero from "../../assets/hero_image.png";
import hero_back from "../../assets/hero_image_back.png";
import hearts from "../../assets/heart.png";
import caolries from "../../assets/calories.png";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";

const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;

  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        <div className="the-best-fit">
          <motion.div
            initial={{ left: mobile ? "165px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>The best fitness club in the town</span>
        </div>
        {/* HERO HESDING */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>

          <div>
            <span>Ideal Body</span>
          </div>

          <div>
            <span>
              In here we will help you shape and build your ideal body and live
              up your life to
            </span>
          </div>
        </div>
        {/*figures */}
        <div className="figures">
          <div>
  <span>  <NumberCounter start={60} end={120} preFix = "+" 
   /></span>
            <span>expert coaches</span>
          </div>
          <div>
            <span>
          <NumberCounter start={60} end={120} preFix = "+" 
   />
   </span>
            <span>member joined</span>
          </div>
          <div>
            <span>
          <NumberCounter start={50} end={100} preFix = "+" 
   />
   </span>
            <span>fitness programs</span>
          </div>
        </div>

        <div className="hero-buttons">
          <div className="btn">Get Started</div>
          <div className="btn">Learn More</div>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Join Now</button>
        <motion.div
          transition={transition}
          whileInView={{ right: "4rem" }}
          initial={{ right: "-1rem" }}
          className="heart-rate"
        >
          <img src={hearts} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>
        {/*hero images */}
        <img src={hero} alt="" className="hero_image" />
        <motion.img
          transition={transition}
          whileInView={{ right: "20rem" }}
          initial={{ right: "11rem" }}
          src={hero_back}
          alt=""
          className="hero_image_back"
        />
        {/*calories */}
        <motion.div
          transition={transition}
          whileInView={{ right: "28rem" }}
          initial={{ right: "37rem" }}
          className="calories"
        >
          <img src={caolries} alt="" />
          <div>
            <span>Calories Burned</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
